import { Grid } from '@mui/material';

import React from 'react';

import { ReactComponent as CloseIcon } from 'common/assets/images/close.svg';
import ButtonComp from 'common/components/Button/ButtonComp';
import ModalEle from 'common/components/Modal/ModalEle';

import styles from './ActionsPrompt.module.scss';

interface IActionsPromptProps {
	mainTitle: string;
	openModal: boolean;
	onCloseModal: () => void;
	subTitle: string;
	data: any;
	actionHandler: (paramsData: any) => void;
	buttonsLabel: string[];
	iconTemplate?: React.ReactElement;
	alertTemplate?: React.ReactElement;
	mainTitleCss?: any;
	showCloseIcon?: boolean;
}

const ActionsPrompt = (props: IActionsPromptProps) => {
	const {
		mainTitle,
		openModal,
		onCloseModal,
		subTitle,
		actionHandler,
		data,
		buttonsLabel,
		alertTemplate,
		mainTitleCss,
		showCloseIcon,
	} = props;
	const { closeImgFillColor } = styles;
	return (
		<ModalEle
			open={openModal}
			handleClose={onCloseModal}
			sxBoxProps={{ width: '30%', height: '30%', margin: 'auto' }}
		>
			<Grid container xs={12} lg={12} sm={12} md={12} direction="row">
				<Grid direction="row" container item xs={12} lg={12} sm={12} md={12}>
					<Grid item xs={12} lg={12} sm={12} md={12}>
						<div className={styles['actions-prompt-title-div']}>
							<span className={mainTitleCss}>{mainTitle}</span>
							{showCloseIcon && (
								<span className={styles['actions-prompt-control-close-icon']}>
									<CloseIcon
										data-testid="on-close"
										onClick={onCloseModal}
										fill={closeImgFillColor}
									/>
								</span>
							)}
						</div>
						<div className={styles['actions-prompt-title-div']}>
							<span className={styles['actions-prompt-title']}>{subTitle}</span>
						</div>
					</Grid>
				</Grid>
				<Grid
					container
					item
					direction="row"
					xs={12}
					lg={12}
					sm={12}
					md={12}
					mt={2}
				>
					<Grid
						item
						xs={12}
						lg={12}
						sm={12}
						md={12}
						className={styles['actions-prompt-alert-div']}
					>
						{alertTemplate}
					</Grid>
				</Grid>
				<Grid
					item
					xs={12}
					lg={12}
					sm={12}
					md={12}
					className={styles['actions-prompt-btngrp']}
				>
					<ButtonComp
						btnType="secondary"
						clickHandler={onCloseModal}
						data-testid="actionsprompt-cancel"
					>
						{buttonsLabel[0]}
					</ButtonComp>
					<ButtonComp
						btnType="primary"
						clickHandler={() => {
							actionHandler(data);
						}}
						data-testid="actionsprompt-save"
					>
						{buttonsLabel[1]}
					</ButtonComp>
				</Grid>
			</Grid>
		</ModalEle>
	);
};

export default ActionsPrompt;
